import questionsV0 from '../../components/LanguageTest/global.locale.questions.v0.json';
import questionsV1 from '../../components/LanguageTest/global.locale.questions.v1.json';
import { LIMIT_TIME_V1 } from './../../constants/subjectTypes';
import { VERSION } from './../../constants/version';
import moment from 'moment';
import * as actionTypes from './actionTypes'
import { profileUpdateStages } from "../profile/actions";

const IS_PROD = process.env.REACT_APP_BUILD === 'prod';

const testStepsRequest = () => ({
  type: actionTypes.TEST_STEPS_REQUEST
});

const testStartComplete = (endTime) => ({
  type: actionTypes.TEST_START_COMPLETE,
  endTime
})

const testStepsComplete = testState => ({
  type: actionTypes.TEST_STEPS_COMPLETE,
  testState,
});

const saveAnswerComplete = (testAnswers, currentStepIndex) => ({
  type: actionTypes.SAVE_ANSWERS_COMPLETE,
  testAnswers,
  currentStepIndex
});

const MAX_QUESTIONS_V0 = IS_PROD ? 45 : 3; //dev fix
const LIMIT_TIME_V0 = 25; // mins
const selectRandomQuestionsV0 = () => {
  const questionsMap = new Map();
  const questionsLen = questionsV0.length;
  let result = [];
  questionsV0.forEach((question, i) => {
    questionsMap.set(i, question);
  });
  for (let i = 0; i < MAX_QUESTIONS_V0; i++) {
    let x = Math.floor(Math.random() * (questionsLen - i));
    let iterator = questionsMap.keys();
    for (let j = 0; j < x; j++) {
      iterator.next();
    }
    const key = iterator.next().value
    result[result.length] = questionsMap.get(key);
    questionsMap.delete(key);
  }

  return result;
};

const getRandomFromArray = (array = [], n = 1) => {
  const shuffled = [...array].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, n);
};

const MAX_CATEGORIES_V1 = IS_PROD ? 12 : 1; //dev fix
// const MAX_CATEGORIES_V1 = IS_PROD ? 12 : 12; //dev fix
// const LIMIT_TIME_V1 = 15; // mins
const selectRandomQuestionsV1 = () => {
  const questionsByCategory = questionsV1.reduce((result, item) => {
    const categoryList = result[item.Type] || [];
    categoryList.push(item);
    result[item.Type] = categoryList;
    return result;
  }, {});

  const categoryList = Object.keys(questionsByCategory);
  const randomCategories = getRandomFromArray(categoryList, MAX_CATEGORIES_V1);

  const result = randomCategories.reduce((result, item) => {
    const questionList = questionsByCategory[item];
    const randomQuestions = getRandomFromArray(questionList, 2);
    return [...result, ...randomQuestions];
  }, []);
  result.sort(() => 0.5 - Math.random());
  return result;
};

const startTest = () => {
  return (dispatch, getState) => {
    const profileState = getState().profile;
    const version = profileState.data.user.scenario_version;
    const limitTime = version === 'v0' ? LIMIT_TIME_V0: LIMIT_TIME_V1;

    let endTime = moment().add(limitTime, 'minutes').toISOString();
    if (version === VERSION.v8 || version === VERSION.v9) {
      let startTime = moment.unix(profileState.data.user.profile.application_overview_timestamp)
      const nowTime = moment.unix(profileState.data.now)
      if (!startTime) { startTime = nowTime }
      const diff = 15 * 60 * 1000 - nowTime.diff(startTime)
      endTime = moment().add(diff, 'milliseconds').toISOString()
    }
    dispatch(testStartComplete(
      endTime
    ));
  }
}

export const loadTest = () => {
  return (dispatch, getState) => {
    const profileState = getState().profile;
    const userId = profileState.data.user.id;
    const version = profileState.data.user.scenario_version;

    dispatch(testStepsRequest());

    dispatch(startTest())

    const localStorageState = localStorage.getItem(`testState.${userId}`);
    const restoredState = localStorageState ? JSON.parse(localStorageState) : {};

    if (!restoredState.testSteps) {
      const randomQuests = version === 'v0' ? selectRandomQuestionsV0() : selectRandomQuestionsV1();
      restoredState.testSteps = [].concat([], randomQuests.map((item) => ({ type: 'languageStep', data: item })));
      restoredState.stepsCount = restoredState.testSteps.length;
    }

    localStorage.setItem(`testState.${userId}`, JSON.stringify(restoredState));

    dispatch(testStepsComplete(restoredState));
  };
};

export const nextStep = (answer) => {
  return (dispatch, getState) => {
    const state = getState().test;
    const profileState = getState().profile;
    const userId = profileState.data.user.id;
    // console.log('state.testSteps: ', state.testSteps);

    if (state.testSteps.length !== 1) {
      if (state.currentStepIndex === state.testSteps.length - 1) {
        dispatch(submitTest(answer));
      }

      if (state.currentStepIndex < state.testSteps.length - 1) {
        const testAnswers = [...state.answers];
        testAnswers[state.currentStepIndex] = answer;
        localStorage.setItem(`testState.${userId}`, JSON.stringify({
          ...state,
          answers: testAnswers,
          currentStepIndex: state.currentStepIndex + 1,
        }));
        dispatch(saveAnswerComplete(
          testAnswers,
          state.currentStepIndex + 1
        ));
      }
    }
  };
};

export const submitTest = (answer) => {
  return (dispatch, getState) => {
    const state = getState().test;

    const testSteps = state.testSteps
    const answers = state.answers
    const profileState = getState().profile;
    const userId = profileState.data.user.id;
    let score = 0
    const failedStep = !answer ? 'timeout' : 'failed'
    const version = profileState.data.user.scenario_version;

    answers[state.currentStepIndex] = answer;

    answers.forEach((item, index) => {
      if (item && item === testSteps[index].data['Correct answer'].toString()) {
        score += 1;
      }
    });

    if (!IS_PROD) {
      score = 24;
    }

    let diff = null;
    if (state.endTime) {
      const startTime = moment(state.endTime).subtract(version === 'v0' ? LIMIT_TIME_V0 : LIMIT_TIME_V1, 'minutes');
      diff = moment().diff(startTime, 'minutes');
    }

    // console.log('.toString(): ', moment().toString());
    // console.log('now: ', moment().format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'));
    // console.log('state.endTime 1: ', moment(state.endTime).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'));
    // console.log('state.endTime 2: ', state.endTime);

    // now:  2021-03-24T11:43:48.560Z
    // state.endTime:  2021-03-24T11:58:44+03:00
    // diff:  0

    const data = { score: score }
    if (version !== VERSION.v8 && version !== VERSION.v9) {
      data.time_passed = diff;
    }
    dispatch(profileUpdateStages(data));

    dispatch({
      type: actionTypes.TEST_SUBMIT_COMPLETE,
      score,
      failedStep: failedStep
    })

    localStorage.removeItem(`testState.${userId}`);
  };
};

export const testFailedComplete = () => (dispatch) => {
  dispatch({
    type: actionTypes.TEST_FAILED_COMPLETE
  })
}



// WEBPACK FOOTER //
// ./src/store/test/actions.js